import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import addPatientsIcon from "../../icons/addPatients.png";
import sadIcon from "../../icons/sad2.png";

// deactivate modal
const DeactivateDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

export function MorePatientModal({ open, handleOk, handleCancel }) {
  return (
    <div>
      <DeactivateDialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent className="deactivateDialogContent">
          <img
            alt="tick icon"
            src={addPatientsIcon}
            width={80}
            height={80}
          ></img>
          <h4 className="text-center">
            You can add 3 patient profiles for free
          </h4>
          <p>Additional patient may cost 200 LKR</p>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          <Link to="/" className="paymentHistoryLink">
            <Button
              variant="contained"
              className="deactivateDialogBtn"
              onClick={handleOk}
            >
              Add Patient
            </Button>
          </Link>
          <Button variant="text" onClick={handleCancel}>
            Cancel
          </Button>
        </DialogActions>
      </DeactivateDialog>
    </div>
  );
}

export function DeactivateModal({ open, handleOk, handleCancel }) {
  return (
    <div>
      <DeactivateDialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent className="deactivateDialogContent">
          <img alt="tick icon" src={sadIcon} width={60} height={60}></img>
          <h4>Deactivate Your Profile ?</h4>
          <h5>* Please verify your profile deletion *</h5>
          <p>
            Please request a "Profile Deactivation" by requesting from
            <a href="mailto:info@deedmed.lk"> Email Us </a> or by
            <a href="https://deedmed.lk/contact/" target="_blank">
              {" "}
              Contact Us{" "}
            </a>
            .
          </p>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          <Link to="/" className="paymentHistoryLink">
            <Button
              variant="contained"
              className="deactivateDialogBtn"
              onClick={handleOk}
            >
              Continue
            </Button>
          </Link>
          <Button variant="text" onClick={handleCancel}>
            Cancel
          </Button>
        </DialogActions>
      </DeactivateDialog>
    </div>
  );
}

export function ChangeDetailModal({ open, handleOk }) {
  return (
    <div>
      <DeactivateDialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent className="deactivateDialogContent">
          <img alt="tick icon" src={sadIcon} width={60} height={60}></img>
          <h4>Change Profile Detail ?</h4>
          <h5>* Please verify to change your profile credentials *</h5>
          <p>
            Please request a "Email address changing" by requesting from
            <a href="mailto:info@deedmed.lk"> Email Us </a> or by
            <a href="https://deedmed.lk/contact/" target="_blank">
              {" "}
              Contact Us{" "}
            </a>
            .
          </p>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          <Link to="/" className="paymentHistoryLink">
            <Button
              variant="contained"
              className="deactivateDialogBtn"
              onClick={handleOk}
            >
              OK
            </Button>
          </Link>
          {/* <Button variant="text" onClick={handleCancel}>
            Cancel
          </Button> */}
        </DialogActions>
      </DeactivateDialog>
    </div>
  );
}

export function ChangeAcceptDetailModal({ open, handleOk, handleCancel }) {
  return (
    <div>
      <DeactivateDialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent className="deactivateDialogContent">
          <img alt="tick icon" src={sadIcon} width={60} height={60}></img>
          <h4>Change Profile Detail ?</h4>
          <h5>* Please verify to change your profile credentials *</h5>
          <p>
            Please be sure before changing the details. Or if you not sure, just
            contact us.
            <a href="mailto:info@deedmed.lk"> Email Us </a> or by
            <a href="https://deedmed.lk/contact/" target="_blank">
              {" "}
              Contact Us{" "}
            </a>
            .
          </p>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          <Link to="/" className="paymentHistoryLink">
            <Button
              variant="contained"
              className="deactivateDialogBtn"
              onClick={handleOk}
            >
              Cancel
            </Button>
          </Link>
          <Button variant="text" onClick={handleCancel}>
            Confirm
          </Button>
        </DialogActions>
      </DeactivateDialog>
    </div>
  );
}
